module.exports = __webpack_public_path__ + "static/kcdc2014-3f9eae138bc87ed646fb100c6e01e3f1.jpeg";